export const joinEnquiryMessage = ({
  enquiryTypes = [],
  message = '',
}: {
  enquiryTypes?: string[];
  message?: string;
} = {}): string => {
  if (enquiryTypes.length === 0) {
    return message;
  }

  const intro = `I'm interested in:\n${enquiryTypes
    .map((type) => `- ${type}`)
    .join('\n')}`;

  return message ? `${intro}\n\n${message}` : intro;
};
